import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState, useCallback } from 'react';

import Alert from '../../Alert';
import Field from '../../Field';
import Label from '../../Label';
import Input from '../../Input';
import Table from '../../Table';
import Modal from '../../Modal';
import Button from '../../Button';
import Tab, { TabOption } from '../reusable/Tab';
import graphFetch from '../../../util/graphFetch';

import {
    getConfig,
    // getAuthUser,
    getSiteMutationSuccess,
} from '../../../redux/selectors';
import { clearSiteMessage } from '../../../redux/actions';

function PublishSiteModal({ site = {}, onClose, onSave }) {
    // const user = useSelector(getAuthUser);
    const { hostInfo } = useSelector(getConfig);
    const successMsg = useSelector(getSiteMutationSuccess);
    const dispatch = useDispatch();
    const [input, setInput] = React.useState({
        name: site.name || '',
        domain: '',
        domainType: 'DORIK_IO',
    });
    const handleSave = React.useCallback(() => {
        onSave(input);
    }, [onSave, input]);
    const handleSelect = React.useCallback(
        (select) => {
            setInput({ ...input, domainType: select.value });
        },
        [input]
    );
    const handleInputChange = React.useCallback(
        (e) => {
            const { name, value } = e.target;
            setInput({ ...input, [name]: value });
        },
        [input]
    );

    useEffect(() => {
        dispatch(clearSiteMessage());
        return () => dispatch(clearSiteMessage());
    }, [dispatch]);

    return (
        <Modal size="sm" dropShadow onClose={onClose} header="PUBLISH SITE">
            <>
                {/* {!user.isVerified &&
                    new Date(user.createdAt).getTime() > 1600195726598 && (
                        <VerifyAlert user={user} />
                    )} */}
                <Field>
                    <Label>Project Name</Label>
                    <Input
                        size="sm"
                        defaultValue={input.name}
                        onChange={(e) =>
                            setInput({ ...input, name: e.target.value })
                        }
                    />
                </Field>
                <Field>
                    <Label>Site URL</Label>
                    <Tab
                        type="boxed"
                        selected={input.domainType}
                        onSelect={handleSelect}
                    >
                        <TabOption value="DORIK_IO">
                            Dorik.io Subdomain
                        </TabOption>
                        <TabOption value="CUSTOM">Custom Domain</TabOption>
                    </Tab>
                </Field>
                <Field>
                    <Input
                        size="sm"
                        name="domain"
                        value={input.domain}
                        groupAppend={
                            input.domainType === 'DORIK_IO' && '.dorik.io'
                        }
                        placeholder={
                            input.domainType === 'DORIK_IO'
                                ? 'example'
                                : 'example.com or subdomain.example.com'
                        }
                        onChange={handleInputChange}
                    />
                </Field>
                {input.domainType === 'CUSTOM' && (
                    <div style={{ marginBottom: 30, fontSize: 14 }}>
                        <p style={{ fontSize: 13 }}>
                            Connect your own domain. Enter your domain name
                            above and add following dns records in your domain
                            control panel.
                        </p>

                        <Table type="primary" data={hostInfo} />

                        <p>
                            Need Help? Check{' '}
                            <a
                                target="_blank"
                                href="http://help.dorik.io/"
                                rel="noopener noreferrer"
                            >
                                How to Configure Custom Domain
                            </a>
                        </p>
                    </div>
                )}

                <div style={{ marginTop: 30 }}>
                    <Button fullWidth size="2x" onClick={handleSave}>
                        Publish Site
                    </Button>
                </div>
                {successMsg && (
                    <Alert type="success" style={{ marginTop: 30 }}>
                        {successMsg}.{' '}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://${site.url}`}
                        >
                            {site.url}
                        </a>
                    </Alert>
                )}
            </>
        </Modal>
    );
}

function VerifyAlert(props) {
    const [success, setSuccess] = useState(null);
    const [loading, setLoading] = useState(false);
    const sendVerificationEmail = useCallback(() => {
        (async () => {
            setLoading(true);
            const options = {
                queryName: 'sendAccountVerificationToken',
                select: 'message success',
            };
            const result = await graphFetch(options);
            setLoading(false);
            if (result?.data?.sendAccountVerificationToken?.success) {
                setSuccess(true);
            }
        })();
    }, []);
    return (
        <>
            {true === success && (
                <Alert type="success" style={{ marginBottom: 30 }}>
                    Verification email has been sent to your registered email
                    address!
                </Alert>
            )}
            {null === success && (
                <Alert type="warning" style={{ marginBottom: 30 }}>
                    You must verify your account to publish site.{' '}
                    {loading ? (
                        <span>Sending</span>
                    ) : (
                        <a href="#" onClick={sendVerificationEmail}>
                            Click here
                        </a>
                    )}{' '}
                    to resend the verification email.
                </Alert>
            )}
        </>
    );
}

export default React.memo(PublishSiteModal);
